import { render, staticRenderFns } from "./Identite.vue?vue&type=template&id=f528d296&scoped=true&"
import script from "./Identite.vue?vue&type=script&lang=js&"
export * from "./Identite.vue?vue&type=script&lang=js&"
import style0 from "./Identite.vue?vue&type=style&index=0&id=f528d296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f528d296",
  null
  
)

export default component.exports